import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { renderInformationItem } from "../productRequestPage/detail";
import { AdminPackages } from "./type";

const AdminPackagesDetail = forwardRef<any, { data: AdminPackages }>((
    { data }, ref
) => {

    const localize = useSelector(getLocalized);

    return <Form
        formData={data}
        ref={ref}
    >   
        <GroupItem>
            <SimpleItem
                dataField={"Name"}
                label = {{
                    text  : localize.getString("name")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Currency"}
                label = {{
                    text  : localize.getString("currency")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"LocationCount"}
                label = {{
                    text  : localize.getString("locationCount")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"PeriodType"}
                label = {{
                    text  : localize.getString("periodtypename")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"ProductCount"}
                label = {{
                    text  : localize.getString("productCount")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Price"}
                label = {{
                    text  : localize.getString("price")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
        </GroupItem>

    </Form>
})

export default AdminPackagesDetail;